import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const FLOATERS = [
  { src: "/img/ring_pineapple.webp", className: "left-[4%] top-[12%] w-24 md:w-44", dur: 7 },
  { src: "/img/chunk_watermelon.webp", className: "right-[6%] top-[18%] w-20 md:w-36", dur: 6 },
  { src: "/img/chunk_pineapple.webp", className: "left-[16%] bottom-[10%] w-20 md:w-32", dur: 8 },
  { src: "/img/chunk_watermelon.webp", className: "right-[18%] bottom-[14%] w-16 md:w-28", dur: 5.5 },
];

export const Indulge = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);

  return (
    <section ref={ref} data-testid="indulge-section" className="relative grain bg-[#E5A910] py-28 md:py-44 overflow-hidden">
      {FLOATERS.map((f, i) => (
        <motion.img
          key={i}
          src={f.src}
          alt=""
          aria-hidden="true"
          className={`absolute ${f.className} drop-shadow-[0_18px_24px_rgba(24,18,3,0.25)]`}
          animate={{ y: [0, -22, 0], rotate: [i % 2 ? 8 : -8, i % 2 ? -6 : 10, i % 2 ? 8 : -8] }}
          transition={{ duration: f.dur, repeat: Infinity, ease: "easeInOut", delay: i * 0.4 }}
        />
      ))}
      <Reveal className="relative max-w-4xl mx-auto px-5 md:px-10 text-center">
        <h2 className="font-display text-5xl md:text-8xl font-extrabold tracking-[-0.04em] leading-[0.95] text-[#181203]">
          Indulge without <span className="font-serif-i">the bulge.</span>
        </h2>
        <p className="mt-8 text-lg md:text-2xl leading-relaxed text-[#2B2008] max-w-2xl mx-auto">
          Sweet juice caters to your sweet tooth and the rest of your body too. <span className="font-bold text-[#181203]">Real sweet, real ingredients.</span>
        </p>
      </Reveal>
    </section>
  );
};
